var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _ellipse, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOcOnTheGo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1327,
    height: 1009,
    viewBox: "0 0 1327 1009",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M407 7.38097C413.4 42.981 448.334 71.881 465 81.881C472.334 81.0476 487.6 76.881 490 66.881C492.4 56.881 498 54.7143 500.5 54.881C503.667 55.2143 510.5 58.081 512.5 66.881C514.5 75.681 524 75.2143 528.5 73.881C528.5 73.881 536.167 95.381 542 102.381V88.881C542.334 82.7143 545.4 71.081 555 73.881C564.6 76.681 563.334 94.0476 561.5 102.381C566.7 112.381 585.667 125.881 594.5 131.381C620.9 34.981 568.167 4.21431 538.5 0.880969C532.834 -0.119031 512.5 0.380969 476.5 10.381C440.5 20.381 415.167 12.5476 407 7.38097Z",
    fill: "#223B41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M550.5 91.881C552.167 94.7143 554.3 101.381 549.5 105.381",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M542.5 89.381C543.334 83.381 547.6 72.181 558 75.381C570.5 79.881 564.6 103.681 553 118.881",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M465.5 82.381C470.5 95.0476 477.5 123.581 465.5 136.381C453.5 149.181 473.5 150.048 485 148.881",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M485 148.881C489.167 165.381 507.9 197.081 549.5 191.881",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M559 205.881L550 192.381",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M592 130.381C588.167 140.214 584.8 163.981 596 178.381",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M481.5 98.381C484.5 95.881 492.4 92.381 500 98.381",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M503 162.381C506.667 162.548 514.5 160.781 516.5 152.381",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 492.5,
    cy: 113.381,
    r: 5.5,
    fill: "#223B41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M613.5 190.381V175.881C613.5 171.381 608 169.281 602 174.881C596 180.481 573.833 195.881 563.5 202.881C558.333 205.714 547.7 213.581 546.5 222.381C545.3 231.181 540.667 243.714 538.5 248.881C530 272.214 505.5 318.881 489 361.881C474.887 398.662 481 441.881 489 460.381C493.757 471.381 519.6 481.281 570 464.881",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M613.5 190.881C632.834 197.381 668.6 229.881 657 307.881C645.4 385.881 658.5 409.381 661 417.881C663.549 426.545 668.5 444.881 650 450.381L619.5 459.381",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M613.5 189.381C595.5 198.214 554.5 221.981 540.5 244.381",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M609 235.881C598.834 234.381 577.8 243.381 575 291.381C572.2 339.381 573.834 409.714 575 438.881C572.167 448.881 568.7 469.981 577.5 474.381C586.3 478.781 596.5 481.881 600.5 482.881C604.834 483.548 614 480.281 616 461.881C618 443.481 631.167 407.881 637.5 392.381C641.834 382.714 647.9 356.181 637.5 327.381C635.167 320.048 630.9 303.181 632.5 294.381",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M507 314.881L489.5 296.381C486.334 292.881 478.1 289.081 470.5 301.881C462.9 314.681 465.667 328.214 468 333.381C471.667 342.548 480.3 363.081 485.5 371.881",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M433.565 248.221C439.965 255.421 432.899 262.554 428.565 265.221C422.965 263.621 416.899 266.887 414.565 268.721C409.065 262.554 398.5 250.381 395 245.881C388.41 237.408 391.28 234.881 399.065 227.221C405 221.381 411 222.381 413.065 224.721C417.232 229.554 427.165 241.021 433.565 248.221Z",
    fill: "#223B41"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M465.5 322.881C464 317.881 456.4 306.281 438 299.881C425.608 295.571 418.568 289.355 414.986 284.381M424.5 285.381C428.834 277.714 440 264.581 450 273.381M479 286.381C477.667 275.548 467.1 254.281 435.5 255.881M414.986 284.381C413.25 281.97 412.327 279.85 412 278.381C410.333 275.381 409.338 268.457 419 265.881C434 261.881 431.5 271.381 428.5 271.881C418.5 273.081 414.324 281.714 414.986 284.381ZM439 285.381C443.5 282.881 454.8 279.981 464 288.381",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M362.5 243.381H383.5M365.5 223.881L382 229.881M376 206.381L391 221.381",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M398.5 779.881C410.9 787.881 429.333 783.214 437 779.881C443.4 776.281 452.5 781.381 459.5 788.381C475 811.881 484.667 817.881 489.5 819.881C492.167 826.214 494 840.981 480 849.381C466 857.781 452.5 849.381 448.5 842.381C443 834.381 446.9 826.581 422.5 823.381C398.1 820.181 387.334 797.048 385 785.881C384.333 780.548 386.1 771.881 398.5 779.881Z",
    fill: "#223B41"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M491 463.881C487 474.714 482.7 500.281 497.5 515.881C501.5 576.548 494.7 713.281 435.5 774.881",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M435.5 774.881C442.167 777.048 457 783.481 463 793.881C470.5 806.881 487.5 823.881 503.5 820.881",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M503.5 820.881L579.5 658.381",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M543 533.881C556.334 585.214 594.2 703.781 639 767.381C642.834 773.381 647.5 791.881 635.5 817.881",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M599 839.881C622.6 833.881 632.834 822.048 635 816.881C639.334 816.381 651.3 817.281 664.5 824.881C677.7 832.481 695 829.048 702 826.381C703.6 831.981 702.667 841.048 702 844.881C697.5 862.381 676 854.881 668.5 858.881C637 871.381 612 867.714 601.5 863.381C590.834 858.048 575.4 845.881 599 839.881Z",
    fill: "#223B41"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M636 817.881C642 816.548 652.283 819.974 663.5 824.882C687.5 835.382 702.167 825.048 715.5 820.382",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M656 449.381C665 472.548 686.2 539.981 699 608.381C715 693.881 725.5 788.881 715.5 820.381",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M561 478.381C561.667 494.381 572.8 531.081 612 549.881",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M576 474.381C573.667 476.881 569.2 483.981 570 492.381",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M600.5 483.381C603.667 491.881 606.3 512.681 591.5 527.881",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1137 406.381C1090.6 390.381 1122 291.381 1143.5 243.881C1179.5 253.481 1217.17 236.881 1231.5 227.381C1232.83 234.548 1240.2 255.981 1259 284.381C1277.8 312.781 1302.18 327.55 1306.5 339.881C1317 369.881 1294 385.381 1282.5 388.881C1242.1 398.081 1208 352.714 1196 328.881C1178.8 399.281 1149.5 409.881 1137 406.381Z",
    fill: "#223B41"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1251.5 116.881C1220.3 122.481 1203.5 84.5477 1199 64.881C1194.84 52.081 1177.5 53.881 1168.5 52.381C1159.5 51.881 1147.3 44.381 1170.5 18.381C1193.7 -7.61904 1216.83 -0.452349 1225.5 6.381C1257.9 5.981 1271.67 39.2143 1274.5 55.881C1279.83 73.881 1282.7 111.281 1251.5 116.881Z",
    fill: "#223B41"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1177,
    cy: 69.881,
    rx: 4,
    ry: 5,
    fill: "#223B41"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1173 52.381C1162 61.381 1145.2 80.681 1166 85.881C1166.17 97.7143 1173.9 120.381 1203.5 116.381V123.881",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1189 90.881C1189 93.881 1188.4 97.681 1182 98.881",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1225.5 108.381V126.381",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1142 172.881C1130.83 180.214 1109.1 197.681 1111.5 208.881C1113.9 220.081 1156.83 220.214 1178 218.881C1190.5 218.881 1216.9 208.381 1222.5 166.381C1228.1 124.381 1217.5 122.707 1209.5 124.381C1202.33 125.881 1186 134.881 1178 158.881C1170 182.881 1170 183.881 1164.5 186.381",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1142 173.381C1142.83 179.881 1146.9 191.181 1164.5 186.381",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1222.5 132.881C1227.5 153.214 1235.8 200.181 1229 225.381",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1151.5 224.881C1147.83 228.214 1144.2 232.481 1145 240.881",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1077.73 87.4755C1069.38 92.8264 1084.05 112.591 1091 122.881L1097.5 130.881C1105.84 132.527 1111.51 124.169 1112.5 119.881L1095.61 89.019C1093.13 86.275 1086.07 82.1247 1077.73 87.4755Z",
    fill: "#223B41"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1095.5 138.881C1093.37 138.374 1090.1 136.82 1088.22 133.881M1088.22 133.881C1087.01 131.987 1086.37 129.517 1087 126.381C1088.6 118.381 1093.33 123.048 1095.5 126.381C1099 131.214 1105.4 142.481 1111 138.881C1116.6 135.281 1109 133.881 1109 125.881C1109.17 120.048 1113 112.281 1127 127.881C1135 136.281 1133.32 148.381 1131.48 153.381M1088.22 133.881C1087.31 137.381 1089.3 145.681 1096.5 146.881M1089 143.381C1088 147.548 1088.8 153.381 1098 155.381M1092 156.381C1093.5 162.048 1100.6 171.881 1117 165.881C1120 165.048 1125.4 168.181 1123 187.381M1139.5 174.881C1140.27 170.388 1139.61 160.249 1131.48 153.381M1129.5 151.881C1130.2 152.36 1130.86 152.861 1131.48 153.381",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1050 104.381H1066M1050 80.381C1050.8 80.781 1061 88.5476 1066 92.381M1066 67.881L1071 81.381",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.5 398.881C1128.83 404.048 1126.5 421.381 1113 411.881C1109.67 408.548 1101.8 403.081 1097 407.881C1092.2 412.681 1101.67 421.548 1107 425.381C1112.5 429.714 1126 437.081 1136 431.881C1146 426.681 1145.83 413.048 1144.5 406.881",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1293 381.381C1296.5 383.048 1303.5 387.681 1303.5 392.881C1299.5 398.548 1293.1 412.481 1299.5 422.881C1305.9 433.281 1317.5 409.548 1322.5 396.381C1325 388.881 1325.3 372.281 1306.5 365.881",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1143.5 428.381C1145.67 432.548 1154.2 438.681 1171 429.881M1154.5 421.381C1159.33 426.214 1173.1 434.181 1189.5 427.381M1177.5 418.881C1183.5 425.881 1200.2 437.181 1219 426.381M1203.5 415.381C1205 421.381 1225.3 434.181 1294.5 437.381",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M748 989.381C781.167 973.714 861.9 943.381 919.5 947.381C927.667 947.714 940 951.181 924 962.381C908 973.581 900 979.381 898 980.881C889.667 987.881 881.5 1002.68 915.5 1005.88C958 1009.88 1078 966.381 1315.5 998.381",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00024 517.226C18.3124 510.071 55.5849 496.219 82.1773 498.045C85.9477 498.198 91.6417 499.781 84.2549 504.896C76.8681 510.01 73.1747 512.659 72.2513 513.344C68.4041 516.541 64.6337 523.3 80.3306 524.761C99.9518 526.588 155.353 506.722 265 521.336",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcOnTheGo);
export default __webpack_public_path__ + "static/media/oc-on-the-go.ba5f620913844b92115f39ed8eca9a25.svg";
export { ForwardRef as ReactComponent };